import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectAllOfficeEntities } from '@features/desks/store/advanceHotDeskingSetup.duck';
import { OfficeEntity } from '@features/desks/services/AdvanceHotDeskingService';

// Maps office id -> display name, prefixing child offices with their root office label.
export function useOfficeNameMap(): Map<number, string> {
  const allOffices = useSelector(selectAllOfficeEntities);

  return useMemo(() => {
    const byId = new Map<number, OfficeEntity>();
    allOffices.forEach((o: OfficeEntity) => byId.set(o.id, o));

    const nameMap = new Map<number, string>();
    allOffices.forEach((o: OfficeEntity) => {
      if (o.parentId) {
        const root = byId.get(o.parentId);
        nameMap.set(o.id, root ? `${root.label} - ${o.label}` : o.label);
      } else {
        nameMap.set(o.id, o.label);
      }
    });
    return nameMap;
  }, [allOffices]);
}
